import { styled } from 'styled-components';

import { colors, cssBreakpoints, gutterWidth, maxWidth } from '#/theme/theme';

export const ViewOrgPageLayoutHeader = styled.header`
  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    margin-bottom: 16px;
    margin-top: 32px;
  }
`;

export const ViewOrgPageFooterHolder = styled.div`
  background: ${colors.backgroundGrey};
  margin-top: 70px;
  padding: 70px 0;
  text-align: center;
`;

export const ViewOrgPageFooterWrapper = styled.div`
  margin: 0 auto;
  max-width: ${maxWidth[3]}px;
  padding: 0 ${gutterWidth / 2}px;
`;

export const ViewOrgPageLayoutSidebarTitle = styled.div`
  /* block-no-empty */
`;

export const ViewOrgPageHeaderSocialLinks = styled.div`
  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    display: none;
  }
`;
